// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 6284) return "static/chunks/6284-3e9925db8c1a3ad6.js";
	if (chunkId === 8341) return "static/chunks/8341-5e08616fa52e4fc1.js";
	if (chunkId === 3865) return "static/chunks/3865-a49fb86349971f6b.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"540":"b67de598457b3f9d","925":"f508c42915eff923","7658":"907be4b9e17564ad","7980":"073b399c81e89718"}[chunkId] + ".js";
};